import { cores, } from "../../Func_genericas/valores_estaticos";
import { CustomThemeProvider } from "../../Styles/theme/customThemeprovider";
import HomeViewTecnico from "../../Styles/layout/homeViewTecnico";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import { func_print } from "../../Func_genericas/func_print";
import { get } from "../../Services/tokenConfig";
import { AuthContext } from "../../AuthContext/AuthContext";
import { useLocation } from "react-router-dom";
import { Box, Snackbar, Tab, Tabs } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { loader } from "../../Func_genericas/loader";
import { Alert } from "../../Components/Alert/Alert";
import { IGrupoTrabalho, ITrabalhador } from "../../Interfaces/maoobra/maoobra";
import { Modaladdtrabalhadores } from "./add_trabalhadores";
import { Modaladdgrupostrabalho } from "./add_grupos_trabalhadores";
import { Modalverhistorico } from "./ver_historico";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(2),
    },
    label: {
      display: "flex",
      flexWrap: "wrap",
      "& > *": {
        // margin: theme.spacing(1),
        // width: theme.spacing(16),
        // height: theme.spacing(16),
        // minWidth: 325,
      },
    },
    header: {
      textAlign: "center",
      background: "#FAFAFA",
      color: "#7e2706",
    },
    picker: {
      color: "#7e2706",
      "&.Mui-checked": {
        color: "#ccafa3",
      },
    },
    tabs: {
      "& .MuiTabs-indicator": {
        backgroundColor: cores.cor1,
        height: 3,
      },
      "& .MuiTab-root.Mui-selected": {
        color: cores.cor1,
      },
    },
  })
);
function Maoobra() {

  const classes = useStyles();

  const auth = useContext(AuthContext);
  const location = useLocation();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [valueTab, setValueTab] = useState("1");

  const [openSnackSuccess, setOpenSnackSuccess] = useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const [list_trabalhadores, set_list_trabalhadores] = useState<ITrabalhador[]>([]);
  const [list_grupos_trabalho, set_list_grupos_trabalho] = useState<IGrupoTrabalho[]>([]);
  const [historico, set_historico] = useState<any>();

  const [flag_open_modal_trabalhadores, set_flag_open_modal_trabalhadores] = useState<boolean>(false);
  const [flag_open_modal_trabalhadores_ver_mais, set_flag_open_modal_trabalhadores_ver_mais] = useState<boolean>(false);
  const [flag_open_modal_trabalhadores_edit, set_flag_open_modal_trabalhadores_edit] = useState<boolean>(false);
  const [flag_open_modal_trabalhadores_add, set_flag_open_modal_trabalhadores_add] = useState<boolean>(false);
  const [obj_new_trabalhador, set_obj_new_trabalhador] = useState<ITrabalhador>()

  const [flag_open_modal_grupos_trabalho, set_flag_open_modal_grupos_trabalho] = useState<boolean>(false);
  const [flag_open_modal_grupos_trabalho_ver_mais, set_flag_open_modal_grupos_trabalho_ver_mais] = useState<boolean>(false);
  const [flag_open_modal_grupos_trabalho_edit, set_flag_open_modal_grupos_trabalho_edit] = useState<boolean>(false);
  const [flag_open_modal_grupos_trabalho_add, set_flag_open_modal_grupos_trabalho_add] = useState<boolean>(false);
  const [obj_new_grupo_de_trabalho, set_obj_new_grupo_de_trabalho] = useState<IGrupoTrabalho>()

  const [flag_open_modal_historico_trabalhadores, set_flag_open_modal_historico_trabalhadores] = useState<boolean>(false);

  const [hover, setHover] = useState<{ flag: boolean; id: number | null }>({ flag: false, id: null });
  const [hover_grupo, setHover_grupo] = useState<{ flag: boolean; id: number | null }>({ flag: false, id: null });

  const get_info_trabalhadores = async () => {
    try {
      func_print('auth.token.cookie_token get_info_trabalhadores', auth.token.cookie_token)

      setIsLoading(true);
      let res = await get(auth.token.cookie_token, 'api/trabalhadores/all/' + location.state);

      set_list_trabalhadores(res.data.result);
      setIsLoading(false);

    } catch (error) {
      func_print("get_info", error, true);
      setIsLoading(false);
    }
  }

  const get_info_grupos = async () => {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, '/api/trabalhadores/grupos/all/' + location.state);

      set_list_grupos_trabalho(res.data.result);

      setIsLoading(false);

    } catch (error) {
      func_print("get_info", error, true);
      setIsLoading(false);
    }
  }


  useEffect(() => {
    (async () => {
      await get_info_trabalhadores();
    })();
  }, []);

  const handleChangeTabNavigation = async (
    event: React.SyntheticEvent,
    newValue: string
  ) => {
    try {
      if (newValue === '1') {
        await get_info_trabalhadores();
      } else if (newValue === '2') {
        await get_info_grupos();
      }
      setValueTab(newValue);
    } catch (error) {
      func_print("handleChangeTabNavigation", error, true);
    }
  };




  return (
    <CustomThemeProvider>
      <Snackbar
        open={openSnackSuccess}
        autoHideDuration={2000}
        onClose={() => setOpenSnackSuccess(false)}
      >
        <Alert
          onClose={() => setOpenSnackSuccess(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSnackError}
        autoHideDuration={2000}
        onClose={() => setOpenSnackError(false)}
      >
        <Alert
          onClose={() => setOpenSnackError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {message}

        </Alert>
      </Snackbar>

      {
        flag_open_modal_trabalhadores === true &&
        <Modaladdtrabalhadores
          list_trabalhadores={list_trabalhadores}
          flag_open_modal={flag_open_modal_trabalhadores}
          set_flag_open_modal={set_flag_open_modal_trabalhadores}
          setMessage={setMessage}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          set_list_trabalhadores={set_list_trabalhadores}
          flag_open_modal_ver_mais={flag_open_modal_trabalhadores_ver_mais}
          set_flag_open_modal_ver_mais={set_flag_open_modal_trabalhadores_ver_mais}
          flag_open_modal_edit={flag_open_modal_trabalhadores_edit}
          set_flag_open_modal_edit={set_flag_open_modal_trabalhadores_edit}
          flag_open_modal_add={flag_open_modal_trabalhadores_add}
          set_flag_open_modal_add={set_flag_open_modal_trabalhadores_add}
          set_obj_new_trabalhador={set_obj_new_trabalhador}
          obj_new_trabalhador={obj_new_trabalhador}
          set_flag_open_modal_historico_trabalhadores={set_flag_open_modal_historico_trabalhadores}
          set_historico={set_historico}
        />
      }
      {
        flag_open_modal_grupos_trabalho === true &&
        <Modaladdgrupostrabalho
          list_trabalhadores={list_trabalhadores}

          list_grupos={list_grupos_trabalho}
          flag_open_modal={flag_open_modal_grupos_trabalho}
          set_flag_open_modal={set_flag_open_modal_grupos_trabalho}
          setMessage={setMessage}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          set_list_grupos={set_list_grupos_trabalho}
          flag_open_modal_ver_mais={flag_open_modal_grupos_trabalho_ver_mais}
          set_flag_open_modal_ver_mais={set_flag_open_modal_grupos_trabalho_ver_mais}
          flag_open_modal_edit={flag_open_modal_grupos_trabalho_edit}
          set_flag_open_modal_edit={set_flag_open_modal_grupos_trabalho_edit}
          flag_open_modal_add={flag_open_modal_grupos_trabalho_add}
          set_flag_open_modal_add={set_flag_open_modal_grupos_trabalho_add}
          set_obj_new_grupo={set_obj_new_grupo_de_trabalho}
          obj_new_grupo={obj_new_grupo_de_trabalho}
        />
      }

      {
        flag_open_modal_historico_trabalhadores === true &&
        <Modalverhistorico
          flag_open_modal={flag_open_modal_historico_trabalhadores}
          set_flag_open_modal={set_flag_open_modal_historico_trabalhadores}
          obj_new={historico}
        />
      }
      <div className={classes.root}>
        <HomeViewTecnico title=" Mão de Obra" />

        <main className={classes.contents}>
          <div className={classes.toolbars} />
          <div className={`${classes.label} p-4`}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1
            }}>
              <Box sx={{ width: "100%" }}>
                <Tabs
                  value={valueTab}
                  variant="fullWidth"
                  onChange={handleChangeTabNavigation}
                  className={classes.tabs}
                >
                  <Tab
                    value="1"
                    label="Trabalhadores"
                    sx={{
                      fontWeight: 700,
                      fontFamily: "candara",
                      fontSize: 18,
                    }}
                  />
                  <Tab
                    value="2"
                    label="Grupos de Trabalho"
                    sx={{
                      fontWeight: 700,
                      fontFamily: "candara",
                      fontSize: 18,
                    }}
                  />

                </Tabs>

                {
                  isLoading === true ?
                    loader() :

                    <div>

                      {
                        valueTab === '1' ?
                          <div className="p-5">
                            <button
                              type="button"
                              onClick={() => {
                                set_flag_open_modal_trabalhadores(true)
                                set_flag_open_modal_trabalhadores_edit(false)
                                set_flag_open_modal_trabalhadores_add(true)
                                set_flag_open_modal_trabalhadores_ver_mais(false)
                                set_obj_new_trabalhador(undefined)

                              }}
                              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                            >
                              <AddIcon sx={{ fontSize: 18 }} />
                              Adicionar Trabalhador
                            </button>
                          </div>
                          : valueTab === '2' ?
                            <div className="p-5">
                              <button
                                type="button"
                                onClick={() => {
                                  set_flag_open_modal_grupos_trabalho(true)
                                  set_flag_open_modal_grupos_trabalho_edit(false)
                                  set_flag_open_modal_grupos_trabalho_add(true)
                                  set_flag_open_modal_grupos_trabalho_ver_mais(false)
                                  set_obj_new_grupo_de_trabalho(undefined)
                                }}
                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                              >
                                <AddIcon sx={{ fontSize: 18 }} />
                                Adicionar Grupo de Trabalho
                              </button>
                            </div>

                            :
                            <></>


                      }


                    </div>
                }
              </Box>


              <div style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {
                  list_trabalhadores.length === 0 && valueTab === '1' ?

                    <div style={{}}
                      className="flex flex-col items-center gap-3"
                    >
                      {/* <img src="/assets/sem_trabalhadores.png" alt="Sem Trabalhadores" style={{ width: 150, height: 150 }} /> */}
                      <p className="text-gray-500 text-lg">Sem trabalhadores registados</p>
                    </div>
                    :
                    list_grupos_trabalho.length === 0 && valueTab === '2' ?
                      <div style={{}}
                        className="flex flex-col items-center gap-3"
                      >
                        {/* <img src="/assets/sem_grupos_trabalho.png" alt="Sem Grupos de Trabalho" style={{ width: 150, height: 150 }} /> */}
                        <p className="text-gray-500 text-lg">Sem grupos de trabalho registados</p>
                      </div>
                      :




                      list_trabalhadores.length > 0 && valueTab === '1' ?

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                          {list_trabalhadores.map((trabalhador, key) => {
                            const isSelected = obj_new_trabalhador?.id_trabalhador === trabalhador.id_trabalhador;
                            const isHovered = hover.flag && hover.id === trabalhador.id_trabalhador;
                            return (
                              <div
                                key={key}
                                // className="w-full max-w-[250px] rounded-2xl border border-gray-200 bg-stone-50 p-4 shadow-sm"
                                className={`
                                  flex flex-col items-center justify-center w-[150px] min-w-[150px] w-full max-w-[250px] p-4 rounded-xl cursor-pointer
                                  transition-all duration-200
                                  ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                                  ${isHovered ? 'shadow-md' : 'shadow-sm'}
                                `}
                                onMouseEnter={() => setHover({ flag: true, id: trabalhador.id_trabalhador })}
                                onMouseLeave={() => setHover({ flag: false, id: trabalhador.id_trabalhador })}

                                onClick={() => {
                                  set_flag_open_modal_trabalhadores(true)
                                  set_obj_new_trabalhador(trabalhador)
                                  set_flag_open_modal_trabalhadores_ver_mais(true)
                                  set_flag_open_modal_trabalhadores_edit(false)
                                  set_flag_open_modal_trabalhadores_add(false)
                                }}
                              >
                                <div className="space-y-2 text-sm">
                                  <div className="flex items-center justify-between gap-3">
                                    <span className="text-gray-500">Nome</span>
                                    <span className="text-gray-800 font-medium truncate">
                                      {trabalhador.nome || '-'}
                                    </span>
                                  </div>
                                  <div className="flex items-center justify-between gap-3">
                                    <span className="text-gray-500">Função</span>
                                    <span className="text-gray-800 font-medium truncate">
                                      {trabalhador.funcao || '-'}
                                    </span>
                                  </div>
                                  <div className="flex items-center justify-between gap-3">
                                    <span className="text-gray-500">NIF</span>
                                    <span className="text-gray-800 font-medium truncate">
                                      {trabalhador.nif || '-'}
                                    </span>
                                  </div>

                                  <div className="flex items-center justify-between gap-3">
                                    <span className="text-gray-500">€/h</span>
                                    <span className="text-gray-800 font-medium">
                                      {trabalhador.custo_hora ?? 0}
                                    </span>
                                  </div>

                                  <div className="flex items-center justify-between gap-3">
                                    <span className="text-gray-500">Contrato</span>
                                    <span className="text-gray-800 font-medium truncate">
                                      {trabalhador.tipo_contrato || '-'}
                                    </span>
                                  </div>

                                  <div className="flex items-center justify-between gap-3">
                                    <span className="text-gray-500">Início</span>
                                    <span className="text-gray-800 font-medium text-right">
                                      {trabalhador.data_inicio_contrato || '-'}
                                    </span>
                                  </div>

                                  <div className="flex items-center justify-between gap-3">
                                    <span className="text-gray-500">Fim</span>
                                    <span className="text-gray-800 font-medium text-right">
                                      {trabalhador.data_fim_contrato || '-'}
                                    </span>
                                  </div>
                                  <div className="flex items-center justify-between gap-3">
                                    <span className="text-gray-500">Email</span>
                                    <span className="text-gray-800 font-medium text-right">
                                      {trabalhador.email || '-'}
                                    </span>
                                  </div>
                                  <div className="flex items-center justify-between gap-3">
                                    <span className="text-gray-500">Telefone</span>
                                    <span className="text-gray-800 font-medium text-right">
                                      {trabalhador.telefone || '-'}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                />



                              </div>
                            )
                          })}
                        </div>
                        :
                        list_grupos_trabalho.length > 0 && valueTab === '2' ?
                          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5"

                          >

                            {
                              list_grupos_trabalho.map((grupo, key) => {
                                const isSelected = obj_new_grupo_de_trabalho?.id_grupo === grupo.id_grupo;
                                const isHovered = hover_grupo.flag && hover.id === grupo.id_grupo;
                                return (
                                  <div
                                    key={key}
                                    className={`
                                      flex flex-col items-center justify-center w-[150px] min-w-[150px] w-full max-w-[250px] p-4 rounded-xl cursor-pointer
                                      transition-all duration-200
                                      ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                                      ${isHovered ? 'shadow-md' : 'shadow-sm'}
                                    `}
                                    onMouseEnter={() => setHover_grupo({ flag: true, id: grupo.id_grupo })}
                                    onMouseLeave={() => setHover_grupo({ flag: false, id: grupo.id_grupo })}
                                    onClick={() => {
                                      set_flag_open_modal_grupos_trabalho(true)
                                      set_obj_new_grupo_de_trabalho(grupo)
                                      set_flag_open_modal_grupos_trabalho_ver_mais(true)
                                      set_flag_open_modal_grupos_trabalho_edit(false)
                                      set_flag_open_modal_grupos_trabalho_add(false)
                                    }}
                                  >
                                    {/* Topo */}
                                    <div className="space-y-2 text-sm">
                                      <div className="flex items-center justify-between gap-3">
                                        <span className="text-gray-500">Nome</span>
                                        <span className="text-gray-800 font-medium truncate">
                                          {grupo.nome || '-'}
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                    />

                                  </div>
                                )
                              })}
                          </div>


                          :

                          <></>
                }



              </div>

            </div>



          </div>
        </main>
      </div>






    </CustomThemeProvider>
  )



}

export default Maoobra;
